/**
@format
@flow
*/
import * as React from 'react';
import ListSquircle from './ListSquircle';
import type { Props as ListSquircleType } from './ListSquircle';
import ListIcon from './ListIcon';
import type { Props as ListIconType } from './ListIcon';

type SquircleType = {|variant?: 'squircle', ...ListSquircleType|};
type IconType = {|variant?: 'icon', ...ListIconType|};

type ListType = SquircleType | IconType;

const List: React$ComponentType<ListType> = (props: Object): React$Node => {
  const {
    variant,
    ...rest
  } = props;

  switch (variant) {
  case 'squircle':
    return <ListSquircle {...rest} />;
  case 'icon':
  default:
    return <ListIcon {...rest} />;
  }
};

export default List;
